import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";
import { FontSizes } from "../../constants";
import {
  ComponentRef,
  getComponentRef,
} from "../../message/components/records/MessageTagUtil";

const TextInput = ({
  label,
  id,
  readOnly,
  placeholderText,
  required,
  onChange,
  multiline,
  value = "",
  handleSubComponentLoaded = (
    subComponent = { ...ComponentRef },
    isLoaded = false
  ) => {},
  itemIndex,
  level,
  messageTime,
}) => {
  const theme = useTheme();

  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    handleSubComponentLoaded(
      getComponentRef("TextInput", itemIndex, level, messageTime),
      true
    );
  }, []);

  const handleOnInputChange = (value) => {
    setInternalValue(value);
    onChange(id, value);
  };

  const renderReadOnly = () => {
    if (!internalValue || internalValue.length === 0) {
      return <></>;
    }
    return (
      <>
        <Grid item container sx={{ marginBottom: "1px", marginTop: "5px" }}>
          <Grid item sx={{ marginRight: "10px" }}>
            <Typography
              sx={{
                fontWeight: "bold",
                color: theme.palette.forms.label,
                fontSize: FontSizes.RegularText,
              }}
            >
              {label}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              sx={{
                color: theme.palette.forms.regular,
                fontSize: FontSizes.RegularText,
              }}
            >
              {internalValue}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  };

  const renderMultiLine = () => {
    return (
      <Box sx={{ marginBottom: 1 }}>
        <TextField
          id={id}
          label={label}
          value={internalValue}
          placeholder={placeholderText}
          sx={{ fontSize: FontSizes.RegularText }}
          onChange={(e) => handleOnInputChange(e.target.value)}
          required={required}
          multiline
          fullWidth
        />
      </Box>
    );
  };

  const renderSingleLine = () => {
    return (
      <Box sx={{ marginBottom: 1 }}>
        <TextField
          id={id}
          label={label}
          placeholder={placeholderText}
          value={internalValue}
          sx={{ fontSize: FontSizes.RegularText }}
          onChange={(e) => handleOnInputChange(e.target.value)}
          required={required}
          fullWidth
        />
      </Box>
    );
  };

  const renderElement = () => {
    if (readOnly) {
      return renderReadOnly();
    } else if (multiline) {
      return renderMultiLine();
    }
    return renderSingleLine();
  };

  return renderElement();
};

TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  placeholderText: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  multiline: PropTypes.bool,
  value: PropTypes.string,
  type: PropTypes.string,
  handleSubComponentLoaded: PropTypes.func,
};

export default TextInput;
